import { ErrorCode, RtcError, loggerManager } from '../..';
import { ProcessHandler, createDecorator } from './middleware';


export const enum CheckPendingPromiseType {
  PENDING = 0,
  RESOLVE = 1,
  REJECT = 2
}

/**
 * 检查一直处于 pending 状态的 promise
 */
export function checkPendingPromise(timeout = 30, type = CheckPendingPromiseType.REJECT) {
  return createDecorator((next: ProcessHandler, name: string) => function (this: any, ...args: any[]) {
    return new Promise<void>((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        const error = new RtcError({ code: ErrorCode.API_CALL_TIMEOUT, message: `checkPendingPromise ${name}() timeout ${timeout}s` });
        (this.log || this._log || loggerManager).warn(error);
        if (type === CheckPendingPromiseType.REJECT) {
          reject(error);
        } else if (type === CheckPendingPromiseType.RESOLVE) {
          resolve();
        }
      }, timeout * 1000);
      if (!this._checkPendingPromiseSet) {
        this._checkPendingPromiseSet = new Set();
      }
      this._checkPendingPromiseSet.add(timeoutId);
      next.apply(this, args).then(resolve, reject)
        .finally(() => {
          clearTimeout(timeoutId);
          if (this._checkPendingPromiseSet && timeoutId) {
            this._checkPendingPromiseSet.delete(timeoutId);
          }
        });
    });
  });
}

export function clearPendingPromise() {
  return createDecorator((next: ProcessHandler, name: string) => function (this: any, ...args: any[]) {
    if (this._checkPendingPromiseSet) {
      this._checkPendingPromiseSet.forEach((id: number) => clearTimeout(id));
      this._checkPendingPromiseSet.clear();
    }
    return next.apply(this, args);
  });
}

